var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"tooltip"},[_c('div',[_c('div',{staticClass:"tw-p-4",attrs:{"data-cy":"birthday"}},[_c('p',{staticClass:"tw-font-semibold"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }